import {Redirect} from 'react-router-dom';

const Login = () => {
  return <Redirect to="/"/>;
};

export default Login;
